import React, { ComponentProps, JSXElementConstructor } from 'react';
import * as ReactDOM from 'react-dom';
import { ConfigProvider, Theme } from '@bedrock/components';
import { ScreenAdapterContext } from '@bedrock/eed-react';
import { useScreenAdapter } from '#features/PxToRemWrapper';

const withFunctionCall = <
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
>(
  OriginalModal: T
): {
  show: (config: Omit<ComponentProps<T>, 'visible' | 'onCancel'>) => {
    close: () => void;
  };
} => {
  const show = (config) => {        
    const div = document.createElement('div');
    document.body.appendChild(div);

    function destroy() {
      const unmountResult = ReactDOM.unmountComponentAtNode(div);
      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div);
      }
      window.removeEventListener('popstate', handlePopState);
    }

    // 监听浏览器的前进后退事件，当用户点击浏览器的前进或后退按钮时，销毁弹框。
    function handlePopState() {
      console.log('popstate event triggered');
      destroy();
      window.removeEventListener('popstate', handlePopState);
    }
    window.addEventListener('popstate', handlePopState);

    function render(props) {
      const screenAdapter = useScreenAdapter.getState();

      const Provider = (props) => (
        <ScreenAdapterContext.Provider value={screenAdapter}>
          <ConfigProvider
            ratio={screenAdapter?.viewBase} // 设置组件内部的ratio，影响组件内部样式；
          >
            <Theme type={'mpc-purple'}>{props.children}</Theme>
          </ConfigProvider>
        </ScreenAdapterContext.Provider>
      );

      ReactDOM.render(
        <Provider>
          <OriginalModal
            visible
            onOk={() => destroy()}
            onCancel={() => destroy()}
            onClose={() => destroy()}
            {...props}
          />
        </Provider>,
        div
      );
    }

    render(config);

    return {
      close: destroy,
    };
  };

  return {
    show,
  };
};

export default withFunctionCall;
